import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { ThemeProvider } from './theme/ThemeProvider'
import { installDevFetchGuard } from './lib/dev-fetch-guard'
import './index.css'
import './styles/standardized-interactions.css'
import './styles/motion.css'
import './styles/mosaic.css'

// Install development fetch guard to catch missing credentials
installDevFetchGuard();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
)